export default __webpack_public_path__ + "static/media/9.2e503aab.jpg";